import { useEffect } from 'react';
import { getViewportWidth } from '@workbench/core';
import LegalNoticeTab from './LegalNoticeTab';
import ProviderTab from './ProviderTab';
import PrivacyStatementTab from './PrivacyStatementTab';
import SettingsTab from './SettingsTab';
import { WbModal, WbModalLevel, WbTab, WbTabContent, WbTabs } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from '../../common/i18n/useTranslation';
import { Theme } from '@mui/material';
import { FooterTabNamesEnum } from '../../utils/enums';
import ThirdPartyLicenseNoticesTab from './ThirdPartyLicenseNoticesTab';

const useStyles = makeStyles()((theme: Theme) => ({
    modal: {
        zIndex: 9999, //needs higher zIndex than Cookiebar
    },
    tabContent: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
}));

interface FooterModalProps {
    hideFooterModal: () => void;
    footerModalTabName: string;
}

export default function FooterModal(props: Readonly<FooterModalProps>) {
    const { classes } = useStyles();
    const translate = useTranslation();

    useEffect(() => {
        // Update the document title using the browser API
        const modal = document.querySelector('wb-modal');

        if (modal) {
            modal.addEventListener('wbmodalclose', () => {
                props.hideFooterModal();
            });
        }
    }, [props]);

    return (
        <WbModal
            modalAriaLabel="footerModal"
            className={classes.modal}
            variant="edit-mobile-fullscreen"
            closeOnBackdropClick
            closeOnEscapeKey
            size="l"
        >
            <WbModalLevel level={1} closeButtonLabel="Close">
                <WbTabs
                    id="tabs"
                    selected={props.footerModalTabName === '' ? 'settings' : props.footerModalTabName}
                    fitted={getViewportWidth() > 767}
                >
                    <WbTab id={FooterTabNamesEnum.PROVIDER} name={FooterTabNamesEnum.PROVIDER}>
                        {translate('provider')}
                    </WbTab>
                    <WbTab id={FooterTabNamesEnum.LEGAL_NOTICES} name={FooterTabNamesEnum.LEGAL_NOTICES}>
                        {translate('legal_notices')}
                    </WbTab>
                    <WbTab id={FooterTabNamesEnum.SETTINGS} name={FooterTabNamesEnum.SETTINGS}>
                        {translate('settings')}
                    </WbTab>
                    <WbTab id={FooterTabNamesEnum.DATA_PROTECTION} name={FooterTabNamesEnum.DATA_PROTECTION}>
                        {translate('data_protection')}
                    </WbTab>
                    <WbTab
                        id={FooterTabNamesEnum.COPYRIGHT_NOTICES_AND_LICENSES}
                        name={FooterTabNamesEnum.COPYRIGHT_NOTICES_AND_LICENSES}
                    >
                        {translate('copyright_notices_and_licenses')}
                    </WbTab>
                    <WbTabContent
                        id="providerTabContent"
                        className={classes.tabContent}
                        name={FooterTabNamesEnum.PROVIDER}
                        slot="content"
                    >
                        <ProviderTab />
                    </WbTabContent>
                    <WbTabContent
                        id="legalNoticeTabContent"
                        className={classes.tabContent}
                        name={FooterTabNamesEnum.LEGAL_NOTICES}
                        slot="content"
                    >
                        <LegalNoticeTab />
                    </WbTabContent>
                    <WbTabContent
                        id="settingsTabContent"
                        className={classes.tabContent}
                        name={FooterTabNamesEnum.SETTINGS}
                        slot="content"
                    >
                        <SettingsTab />
                    </WbTabContent>
                    <WbTabContent
                        id="dataProtectionTabContent"
                        className={classes.tabContent}
                        name={FooterTabNamesEnum.DATA_PROTECTION}
                        slot="content"
                    >
                        <PrivacyStatementTab />
                    </WbTabContent>
                    <WbTabContent
                        id="copyrightNoticesLicensesTabContent"
                        className={classes.tabContent}
                        name={FooterTabNamesEnum.COPYRIGHT_NOTICES_AND_LICENSES}
                        slot="content"
                    >
                        <ThirdPartyLicenseNoticesTab />
                    </WbTabContent>
                </WbTabs>
            </WbModalLevel>
        </WbModal>
    );
}
